/**
 * Scope 표시 규약 — 그룹 색(테마 토큰). 카탈로그(types/scope.ts)의 시각 짝.
 * 계통은 자기 그룹의 색을 쓴다: 어떤 ScopeId 든 scopeColors(id).
 * 라벨은 카탈로그의 short/label 이 SSOT (scopeShortLabel/scopeLabel).
 */
import { scopeGroupOf, type ScopeGroup } from '@/types/scope';

export interface ScopeColorSet {
  bg: string;
  color: string;
  border: string;
}

// theme-aware CSS variables defined in src/theme/tokens.css
export const SCOPE_COLORS: Record<ScopeGroup, ScopeColorSet> = {
  primary:   { bg: 'var(--scope-primary-bg)',   color: 'var(--scope-primary-fg)',   border: 'var(--scope-primary-fg)' },
  secondary: { bg: 'var(--scope-secondary-bg)', color: 'var(--scope-secondary-fg)', border: 'var(--scope-secondary-fg)' },
  bop:       { bg: 'var(--scope-bop-bg)',       color: 'var(--scope-bop-fg)',       border: 'var(--scope-bop-fg)' },
};

const UNKNOWN_SCOPE_COLORS: ScopeColorSet = {
  bg: 'var(--bg-panel)',
  color: 'var(--text-muted)',
  border: 'var(--text-muted)',
};

/** ScopeId(그룹/계통) → 그 그룹의 색. 미지 id 는 중립색 */
export function scopeColors(id: string): ScopeColorSet {
  const group = scopeGroupOf(id);
  return group ? SCOPE_COLORS[group] : UNKNOWN_SCOPE_COLORS;
}
